import { Ban, LogOut, UserCheck } from "lucide-react";
import { getToken, setToken } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { t } from "@/i18n";

// The platform console signs in as an agency user with a short-lived token. The admin's own token is kept here
// so "Exit" returns to the console without a new login.
const ADMIN_KEY = "inm_admin_token";

export function startImpersonation(token) {
  const mine = getToken();
  if (mine) sessionStorage.setItem(ADMIN_KEY, mine);
  setToken(token);
  window.location.assign("/app");
}

export function exitImpersonation() {
  const admin = sessionStorage.getItem(ADMIN_KEY);
  sessionStorage.removeItem(ADMIN_KEY);
  setToken(admin || null);
  window.location.assign(admin ? "/app" : "/login");
}

export function ImpersonationBanner() {
  const { user, agency } = useAuth();
  if (!user?.impersonated_by) return null;
  return (
    <div className="fixed inset-x-0 bottom-0 z-[60] flex flex-wrap items-center justify-center gap-3 bg-[#7C2D12] px-4 py-2 text-sm text-white shadow-lg" data-testid="impersonation-banner">
      <UserCheck className="h-4 w-4" />
      <span>{t("Platform console: you're signed in as {name} ({agency}). Every change is logged.", { name: user.name || user.email, agency: agency?.name || "—" })}</span>
      <button onClick={exitImpersonation} className="inline-flex items-center gap-1.5 rounded-full border border-white/40 px-3 py-1 text-xs font-medium hover:bg-white/10" data-testid="impersonation-exit"><LogOut className="h-3.5 w-3.5" />{t("Back to console")}</button>
    </div>
  );
}

// Members of a suspended agency see this instead of the dashboard.
export function SuspendedScreen() {
  const { agency, signOut } = useAuth();
  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-6 text-foreground" data-testid="agency-suspended-screen">
      <div className="max-w-md rounded-2xl border bg-card p-8 text-center">
        <Ban className="mx-auto h-8 w-8 text-red-600" />
        <h1 className="mt-4 text-xl font-semibold">{t("This agency account is suspended")}</h1>
        <p className="mt-2 text-sm text-muted-foreground">{t("The dashboard and the website for {agency} are switched off. Contact InmoTera support to restore access.", { agency: agency?.name || "—" })}</p>
        <button onClick={() => { signOut(); window.location.assign("/login"); }} className="mt-6 inline-flex items-center gap-2 rounded-lg border px-4 py-2 text-sm" data-testid="suspended-logout"><LogOut className="h-4 w-4" />{t("Log out")}</button>
      </div>
    </div>
  );
}
